<script setup>
import { ref, onMounted } from 'vue'
import { useTranslation } from 'i18next-vue'
import { useLanguage } from '@/composables/useLanguage'
import { SUPPORTED_LANGUAGES } from '@/constants/languages'

const { t } = useTranslation()
const { currentLanguage, currentLanguageConfig, changeLanguage } = useLanguage()

const menu = ref(false)
const mounted = ref(false)

onMounted(() => {
  mounted.value = true
})

const handleLanguageChange = async (langCode) => {
  await changeLanguage(langCode)
  menu.value = false
}
</script>

<template>
  <div v-if="mounted">
    <v-menu v-model="menu" location="bottom end">
      <template v-slot:activator="{ props }">
        <v-btn
          v-bind="props"
          variant="text"
          size="small"
          class="language-btn"
        >
          <img
            :src="currentLanguageConfig.flagPath"
            :alt="currentLanguageConfig.flagAlt"
            class="flag-icon"
          />
          <v-icon size="small" class="chevron ml-1">mdi-chevron-down</v-icon>
        </v-btn>
      </template>

      <v-list density="compact">
        <v-list-item
          v-for="lang in SUPPORTED_LANGUAGES"
          :key="lang.code"
          :value="lang.code"
          :class="{ 'v-list-item--active': currentLanguage === lang.code }"
          @click="handleLanguageChange(lang.code)"
        >
          <template v-slot:prepend>
            <img
              :src="lang.flagPath"
              :alt="lang.flagAlt"
              class="flag-icon mr-2"
            />
          </template>
          <v-list-item-title>{{ t(lang.translationKey) }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<style scoped>
.flag-icon {
  width: 20px;
  height: 14px;
  object-fit: cover;
  border-radius: 2px;
}

.language-btn {
  min-width: auto;
  padding: 4px 8px;
}

/* Tight layouts (landing page header, login corner): hide chevron and
   tighten padding so the selector fits alongside other controls. */
@media (max-width: 600px) {
  .language-btn {
    padding: 4px 6px;
  }
  .language-btn .chevron {
    display: none;
  }
}
</style>
